<script>
  import {IMAGES} from '../images';

  const images = ['TWITTER', 'BLOOMBERG', 'NASDAQ', 'COIN_GECKO', 'COIN_MARKET_CAP', 'TRADING_VIEW', 'SIMPLEX', 'CHAINALYSIS', 'JUMIO', 'MOONPAY', 'SOURCE'];
</script>

<style>
  .wrap {
    height: 166px;
    background: #f9f9f9;
    overflow: hidden;
  }
  .scroller {
    top: 50%;
    padding: 0 80px;
    transform: translateY(-50%);
    animation: move 35s linear infinite;
  }
  .scroller:hover {
    animation-play-state: paused;
  }
  img {
    margin-left: 80px;
    height: 48px;
  }
  img:first-child {
    margin-left: 0;
  }
  @keyframes move {
    0% {
      transform: translate(0, -50%);
    }
    100% {
      transform: translate(calc(-50% + 40px), -50%);
    }
  }
</style>

<section class="wrap pr over">
  <div class="scroller df aic jcsb pa">
    {#each [...images, ...images] as img}
      <img src={IMAGES[img]} alt={img} />
    {/each}
  </div>
</section>
